import { useCallback } from "react";
import { useAppSelector } from "../../../store/hook";

/**
 * Helpers tied to `state.rbac.pendingActionId` so individual rows / buttons
 * can show a loader without each component duplicating selector logic.
 */
export const useRbacAction = () => {
  const pendingActionId = useAppSelector((s) => s.rbac.pendingActionId);

  const isBusy = pendingActionId != null;

  const matches = useCallback(
    (op: string, id?: number | string) => {
      if (!pendingActionId) return false;
      if (id === undefined) return pendingActionId.startsWith(`${op}`);
      return pendingActionId === `${op}:${id}`;
    },
    [pendingActionId]
  );

  return { pendingActionId, isBusy, matches };
};
